export const LIVE = 'live';
const DRAFT = 'draft';
const UNPUBLISHED = 'unpublished';
const NO_PAGES = 'no pages';

export const getPageStatusProps = ({ live, unpublishedChanges, key = 'icon' }) => {
  const text = getPageStatusText({ live, unpublishedChanges });
  const statuses = {
    [LIVE]: {
      [key]: 'success',
      context: 'positive',
      text,
    },
    [DRAFT]: {
      [key]: 'draft',
      context: 'secondary',
      text,
    },
    [UNPUBLISHED]: {
      [key]: 'warning',
      context: 'negative',
      text,
    },
  };

  if (!live) {
    return statuses[DRAFT];
  }
  if (unpublishedChanges) {
    return statuses[UNPUBLISHED];
  }

  return statuses[LIVE];
};

export const getPageStatusText = ({ live, unpublishedChanges }) => {
  const statuses = {
    [LIVE]: 'This page is live.',
    [DRAFT]: 'This page is a draft.',
    [UNPUBLISHED]: 'This page has unpublished changes.',
  };

  if (!live) {
    return statuses[DRAFT];
  } if (unpublishedChanges) {
    return statuses[UNPUBLISHED];
  }

  return statuses[LIVE];
};

export const getPageStatusShorthand = ({ live, unpublishedChanges }) => {
  const statuses = {
    [LIVE]: 'Live',
    [DRAFT]: 'Draft',
    [UNPUBLISHED]: 'Live\n(unpublished changes)',
  };
  if (!live) {
    return statuses[DRAFT];
  } if (unpublishedChanges) {
    return statuses[UNPUBLISHED];
  }
  return statuses[LIVE];
};

export async function getStatusFromPages(pages) {
  if (!pages || !pages.length) return NO_PAGES;
  const hasLivePage = !!pages.filter(page => page.live).length;
  return hasLivePage ? LIVE : DRAFT;
}
